import { useEffect, useState } from "react";
import { TradeInAemSearchType } from "../utils/constants";
import { useTradeInAemLabel } from "../utils/labels";
import { useTradeInCsl } from "../csl/tradeInCslUtils";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../redux/store";
import { tradeInAemSetSearchValue } from "../redux/actions/TradeInAemFindVehicleActions";
import { useDispatch } from "../../shared-logic/redux/store";
import { TradeInAemFindVehicleStatus } from "../utils/types";

type UseFindVehicleSearch = {
    searchValue: string;
    setSearchValue: (value: string) => void;
    error?: string;
    findVehicle: () => void;
    labels: {
        titleLabel: string;
        descriptionLabel: string;
        placeholderLabel: string;
    };
};

const useFindVehicleSearch = (type: TradeInAemSearchType): UseFindVehicleSearch => {
    const csl = useTradeInCsl();
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const searchValue = useTradeInAemSelector((state) => state.tradeInAemFindVehicle.searchValue);
    const searchType = useTradeInAemSelector((state) => state.tradeInAemFindVehicle.searchType);
    const searchFailed = useTradeInAemSelector(
        (state) => state.tradeInAemFindVehicle.searchStatus === TradeInAemFindVehicleStatus.Failed,
    );
    const useTestData = useTradeInAemSelector((state) => state.tradeInAemUtils.useTestData);

    const licensePlateLabels = useTradeInAemLabel([
        "tradeInAemFindVehicleLicensePlateTitle", // titleLabel
        "tradeInAemFindVehicleLicensePlateDescription", // descriptionLabel
        "tradeInAemFindVehicleLicensePlatePlaceHolder", // placeholderLabel
        "tradeInAemFindVehicleLicensePlateError", // errorLabel
    ]);

    const vinNumberLabels = useTradeInAemLabel([
        "tradeInAemFindVehicleVinNumberTitle", // titleLabel
        "tradeInAemFindVehicleVinNumberDescription", // descriptionLabel
        "tradeInAemFindVehicleVinNumberPlaceHolder", // placeholderLabel
        "tradeInAemFindVehicleVinNumberError", // errorLabel
    ]);
    const requiredLabel = useTradeInAemLabel("tradeInAemFieldRequired");

    const [requiredError, setRequiredError] = useState(false);

    const [titleLabel, descriptionLabel, placeholderLabel, errorLabel] =
        type === TradeInAemSearchType.LicensePlate ? licensePlateLabels : vinNumberLabels;
    const labels = { titleLabel, descriptionLabel, placeholderLabel };

    let error;
    if (requiredError) error = requiredLabel;
    else if (searchFailed) error = errorLabel;

    const findVehicle = (): void => {
        setRequiredError(false);
        if (searchValue) csl.fetchVehicleResults(searchValue, type);
        else setRequiredError(true);
    };

    const setSearchValue = (value: string): void => {
        dispatch(tradeInAemSetSearchValue(value, type));
    };

    // Prefill license plate and or VIN if useTestData is true and testPlates or testVin are available
    useEffect(() => {
        if (useTestData && csl.enableLicensePlate && csl.testPlates.length > 0) {
            dispatch(tradeInAemSetSearchValue(csl.testPlates[0].value, TradeInAemSearchType.LicensePlate));
        }
        if (useTestData && csl.enableVin && csl.testVins) {
            dispatch(tradeInAemSetSearchValue(csl.testVins[0].value, TradeInAemSearchType.VinNumber));
        }
    }, []);

    return { searchValue: type === searchType ? searchValue : "", setSearchValue, labels, error, findVehicle };
};
export default useFindVehicleSearch;
